import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, func, shape } from "prop-types";
import { actions as echeckActions } from "reducers/echecks";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import Button from "pages/_components/Button";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import SelectorInput from "pages/_components/fields/formik/SelectorInput";
import { documentTypeFormats } from "util/format";

class AddBeneficiary extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
        values: shape({}).isRequired,
        setValues: func.isRequired,
        isSubmitting: bool.isRequired,
        setOpenSidebarForm: func.isRequired,
    };

    render() {
        const { handleSubmit, values, setValues, isSubmitting, setOpenSidebarForm } = this.props;

        return (
            <div className="container">
                <I18n id="cedip.new.beneficiary" component="h2" />
                <Form
                    className="above-the-fold"
                    onSubmit={(e) => {
                        handleSubmit(e, setOpenSidebarForm);
                        e.stopPropagation();
                    }}>
                    <Field
                        component={SelectorInput}
                        name="document"
                        hidePlaceholder
                        selectProps={{
                            name: "documentType",
                            value: {
                                value: values.type,
                                label: values.type,
                            } /* values.documentType */,
                            options: [
                                { value: "CUIT", label: "CUIT" },
                                { value: "CUIL", label: "CUIL" },
                            ],
                        }}
                        isFocused
                        label={i18n.get(`cedips.document`)}
                        inputProps={{
                            name: "document",
                            value: values.document,
                            inputmode: "numeric",
                        }}
                        onChange={(type, stringDocument) => {
                            setValues({
                                ...values,
                                type: type?.value ? type.value : type,
                                document: stringDocument,
                            });
                        }}
                        variant="standard"
                    />
                    <Button type="submit" className="btn-primary" label="global.add" loading={isSubmitting} />
                </Form>
            </div>
        );
    }
}

export default compose(
    connect(),
    withFormik({
        mapPropsToValues: () => ({
            type: "CUIT",
            document: "",
        }),
        handleSubmit: (form, formikBag) => {
            const { setSubmitting, setErrors, resetForm } = formikBag;
            const { dispatch, type, setOpenSidebarForm } = formikBag.props;

            if (form.document === "") {
                setErrors({
                    document: i18n.get("global.error.required"),
                });
                setSubmitting(false);
            } else if (documentTypeFormats(form.type, form.document)) {
                dispatch(
                    echeckActions.bankedBeneficiary(
                        form,
                        setSubmitting,
                        type,
                        setErrors,
                        setOpenSidebarForm,
                        resetForm,
                    ),
                );
                setSubmitting(true);
            } else {
                setErrors({
                    document: i18n.get("global.incorrect.format"),
                });
                setSubmitting(false);
            }
        },
    }),
)(AddBeneficiary);
